import TagManager from 'react-gtm-module'
import { userGroupService } from '$utils/services/userGroupService'
import { localUserIdData } from '$utils/services/saveUserIdDataService/saveUserIdDataService'
import { isUserAuthenticated } from '$services/session/isAuthenticated/isAuthenticated.service'

interface WindowWithNativeProps extends Window {
  ReactNativeWebView?: any
}

const getPlatformType = () => {
  const windowsWithNativeProps: WindowWithNativeProps = window
  if (windowsWithNativeProps.ReactNativeWebView) {
    return { platformType: 'App' }
  }
  return { platformType: 'Web' }
}

const initialize = () => {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
    dataLayer: { ...getPlatformType() },
  }

  TagManager.initialize(tagManagerArgs)
}

const getTagManagerUserType = () => {
  if (userGroupService.isCaretaker()) {
    return { userType: 'Cuidador' }
  }
  if (userGroupService.isNormalCustomer() || userGroupService.isGuest()) {
    return { userType: 'Particular' }
  }
  if (userGroupService.isResidenceAdmin() || userGroupService.isResidenceModerator()) {
    return { userType: 'Residencia' }
  }
  if (userGroupService.isRecruiter()) {
    return { userType: 'Empresa' }
  }
  if (userGroupService.isCallcenter()) {
    return { userType: 'Call Center' }
  }

  return undefined
}

const getTagManagerUserPremium = () => {
  const userData = localUserIdData.getUserIdData()
  if (!isUserAuthenticated()) {
    return undefined
  }

  if (userData.hasActivePremiumSubscription) {
    return { fUserType: 'Premium' }
  }

  if (userData.hasActiveProSubscription) {
    return { fUserType: 'Pro' }
  }

  return { fUserType: 'Freemium' }
}

const getTagManagerUserId = () => {
  const userData = localUserIdData.getUserIdData()
  if (userData.id) {
    return { userId: userData.id }
  }

  return undefined
}

const push = dataLayerEvent => {
  TagManager.dataLayer({
    dataLayer: {
      ...getTagManagerUserType(),
      ...getTagManagerUserPremium(),
      ...dataLayerEvent,
      ...getPlatformType(),
      ...getTagManagerUserId(),
    },
  })
}

export const tagManager = {
  initialize,
  push,
}



// WEBPACK FOOTER //
// ./src/infrastructure/tagManager/tagManager.ts